import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { sceneImages } from '../../data/images';
import { pricingConfig } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatMoney, priceBundle } from '../../utils/pricing';
export function PathChooser() {
  const {
    t,
    lang
  } = useLanguage();
  const minPer = Math.min(...pricingConfig.bundles.map(b => priceBundle(b).perUnit));
  const paths = [{
    to: '/build',
    title: t('paths.byo'),
    headline: t('byo.headline'),
    body: 'Choose exactly how many M1 PRO lights you need — from a single light to a full custom installation.',
    meta: `From ${formatMoney(pricingConfig.unitPrice, lang)} per light`,
    image: sceneImages.poolSteps
  }, {
    to: '/systems',
    title: t('paths.systems'),
    headline: t('systems.headline'),
    body: 'Professionally configured systems of 2 to 24 lights — save up to $238.85 versus buying lights individually, with a Lifetime Warranty on 4+ lights.',
    meta: `As low as ${formatMoney(minPer, lang)} per light`,
    image: sceneImages.mediumPool
  }];
  return <div className="grid gap-5 lg:grid-cols-2" data-id="element-810" data-mp="ssljve0wtyem">
      {paths.map(p => <Link key={p.to} to={p.to} className="group relative flex min-h-[460px] flex-col justify-end overflow-hidden rounded-2xl border mf-hairline" data-id="element-811" data-mp="ntiflvsr7w7p">
          <img src={p.image} alt="" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:scale-[1.03]" data-id="element-812" data-mp="xrg32h2shoz9" />
          <div className="absolute inset-0 bg-[#030A14]/60" aria-hidden data-id="element-813" data-mp="17gzonuhvzwxt" />
          <div className="relative p-7 md:p-10" data-id="element-814" data-mp="1lgr6k6bixxh3">
            <span className="text-sm font-medium text-ice" data-id="element-815" data-mp="1lhipohnxq2qh">{p.title}</span>
            <h3 className="mt-2 font-display text-4xl font-semibold uppercase leading-[0.95] md:text-5xl" data-id="element-816" data-mp="1giz3qh9ccqy4">{p.headline}</h3>
            <p className="mt-4 max-w-md text-titanium" data-id="element-817" data-mp="e62xvkloih7u">{p.body}</p>
            <div className="mt-6 flex items-center justify-between gap-4 border-t border-white/15 pt-5" data-id="element-818" data-mp="i5bq2l12m71a">
              <span className="text-sm text-white" data-id="element-819" data-mp="n4y5900glxcq">{p.meta}</span>
              <span className="inline-flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-820" data-mp="rvwljzlg6vfz">
                {lang === 'es' ? 'Comenzar' : 'Start here'}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" data-id="element-821" data-mp="11u2kq9fvdnh5" />
              </span>
            </div>
          </div>
        </Link>)}
    </div>;
}